import React from "react";
import { Clock, Lock, Send } from "lucide-react";

import { canSendLetterNow } from "../../utils/letterSend";

function LetterRecipientsBar({ letter, recipients, onSendNow, isReadOnly }) {
  const canSend = canSendLetterNow(letter, recipients);

  return (
    <div className="shrink-0 border-b border-greyLight/40 bg-pageBg/40 px-4 py-3 sm:px-6 lg:px-8">
      <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div className="flex min-w-0 flex-1 items-center justify-center gap-2 sm:justify-start lg:justify-center">
          {isReadOnly ? (
            <Lock size={14} className="shrink-0 text-textMuted" />
          ) : (
            <Clock size={14} className="shrink-0 text-brandPurple" />
          )}
          <p
            className={`min-w-0 text-center font-josefin text-[11px] font-medium uppercase tracking-wide sm:text-xs ${
              isReadOnly ? "text-textMuted" : "text-brandPurple"
            }`}
          >
            {isReadOnly
              ? "Lettre envoyée · lecture seule"
              : canSend
                ? "Programmée · envoi immédiat possible"
                : "Envoyée · livraison en cours"}
          </p>
        </div>
        {canSend && !isReadOnly && (
          <button
            type="button"
            onClick={onSendNow}
            className="mx-auto flex w-full max-w-xs shrink-0 items-center justify-center gap-2 rounded-md bg-sageDark px-4 py-2.5 font-josefin text-sm font-medium text-white transition hover:bg-modalSage sm:mx-0 sm:w-auto sm:px-5"
          >
            <Send size={15} />
            Envoyer maintenant
          </button>
        )}
      </div>
    </div>
  );
}

export default LetterRecipientsBar;
